import {Layout, Tabs, Steps, Typography} from "antd";
import TagManager from "../../TagManager/TagManager";
import ModelTraining from "../ModelTraining/ModelTraining";
import TestModel from "../TestModel/TestModel";
import ConfigEditor from "../../ConfigEditor/ConfigEditor";
import ProfilesTab from "../../ConfigEditor/ProfilesTab";
import React, {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AuthContext} from "../../Auth/AuthProvider";
import {getConfig, getModels, getTags} from "../../util/redux/asyncActions";
import {WORKFLOW_STEPS} from "../../util/constants";
import {TagsOutlined, ExperimentOutlined, SettingOutlined, BugOutlined, ThunderboltOutlined, ProfileOutlined} from "@ant-design/icons";
import AppHeader from "../../AppHeader/AppHeader";

const {Content} = Layout;
const {Text} = Typography;

const MlTraining = () => {
    const [activeTab, setActiveTab] = useState("0");
    const dispatch = useDispatch();
    const userManager = useContext(AuthContext);
    const config = useSelector(state => state.request.config);
    const models = useSelector(state => state.request.models);
    const allEntities = useSelector(state => state.request.all_entities);

    const STEP_ICONS = {
        tags: <TagsOutlined/>,
        experiment: <ExperimentOutlined/>,
        setting: <SettingOutlined/>,
        bug: <BugOutlined/>,
        profile: <ProfileOutlined/>,
        thunderbolt: <ThunderboltOutlined/>,
    };

    useEffect(() => {
        if (config === undefined) dispatch(getConfig({userManager}));
        if (!models || models.length === 0) dispatch(getModels({userManager}));
        if (!allEntities || allEntities.length === 0) dispatch(getTags({userManager}));
    }, []);

    const tabItems = [
        {label: "Tags", key: "0", children: <TagManager/>},
        {label: "Model Training", key: "1", children: <ModelTraining/>},
        {label: "Configure", key: "2", children: <ConfigEditor/>},
        {label: "Profiles", key: "3", children: <ProfilesTab/>},
        {label: "Test Model", key: "4", children: <TestModel/>},
    ];

    return (
        <Layout style={{minHeight: "100vh", backgroundColor: "#f7f8fa"}}>
            {/* App header with area switch */}
            <AppHeader area="mltraining"/>

            {/* Workflow stepper */}
            <div style={{
                padding: "20px 32px 0",
                backgroundColor: "#fff",
                borderBottom: "1px solid #f0f0f0",
            }}>
                <Steps
                    current={parseInt(activeTab)}
                    size="small"
                    items={WORKFLOW_STEPS.map(step => ({
                        title: step.title,
                        description: step.description,
                        icon: STEP_ICONS[step.icon]
                    }))}
                    onChange={(stepIndex) => setActiveTab(String(stepIndex))}
                    style={{marginBottom: 20}}
                />
            </div>

            {/* Tab content */}
            <Content style={{padding: "24px"}}>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    centered
                    items={tabItems}
                    tabBarStyle={{display: "none"}}
                />
            </Content>
        </Layout>
    );
};

export default MlTraining;
